import { MicrophoneIcon as PhosphorMicrophoneIcon } from "@phosphor-icons/react/dist/ssr/Microphone";

import { createAppIcon } from "@/components/createAppIcon";

export const MicrophoneIcon = /* @__PURE__ */ createAppIcon(PhosphorMicrophoneIcon);
